const i18nService = {
  defaultLanguage: "en",

  languages: [
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "media/flags/226-united-states.svg"
    },
    {
      lang: "nl",
      name: "Dutch",
      flag: process.env.BASE_URL + "media/flags/237-netherlands.svg"
    },
    {
      lang: "be",
      name: "Dutch",
      flag: process.env.BASE_URL + "media/flags/165-belgium.svg"
    },
    {
      lang: "dk",
      name: "Danish",
      flag: process.env.BASE_URL + "media/flags/174-denmark.svg"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  }
};

export default i18nService;
